import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import "./Resources/css/styles.css";

// import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import promiseMiddleware from 'redux-promise';
import rootReducer from './redux/reducers'
import ReduxThunk from 'redux-thunk'
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
// import services get template
import { getTemplates, getCategoriesData } from "../src/redux/actions/templates_actions";
import { HOST_URL } from "../src/utils/misc";

// Config Store and Persist Reducer
const bindMiddleware = (middleware) => {
  return applyMiddleware(middleware,ReduxThunk);
};
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cart", "templates"],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, bindMiddleware(promiseMiddleware));
const persistor = persistStore(store);

store.dispatch(getTemplates()).then(res => {
  if(res.payload) {
    //Style html
    document.title = `${res.payload.templateProperties.store_name}`;
    let link = document.querySelector('link[rel="shortcut icon"]') || document.querySelector('link[rel="icon"]');
    if (!link) {
        link = document.createElement('link');
        link.id = 'favicon';
        link.rel = 'shortcut icon';
        document.head.appendChild(link);
    }
    link.href = `${HOST_URL}${res.payload.templateProperties.shortcut_icon}`;
  }
});

store.dispatch(getCategoriesData())

ReactDOM.render(
    <Provider store={store}>
      <PersistGate 
        persistor={persistor}
        loading={null}
      >            
        <App />
      </PersistGate>
    </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();